<template lang="pug">
  .chat_services__item(@click="active", :class="{ active: isFocus }")
    .services_item__preview(:style="{ 'background-image': 'url(' + services.preview + ')' }")
    .services_item__info
      .services_item__title
        span {{ services.title }}
        span {{ services.price }}
      .services_item__descriprion
        span {{ services.order }}
        span {{ services.status }}
    .services_item__action
      v-icon(size="24") mdi-dots-vertical
</template>

<script>

export default {
  data() {
    return { isFocus: false };
  },
  methods: {
    active() { this.isFocus = !this.isFocus; }
  },
  props: {
    services: { type: Object, required: false }
  }
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .chat_services__item {
    background: $dark-theme-disabled-text;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 18px 0;
    border-bottom: 1px solid $grey-light7;
    position: relative;

    &.active {
      background: $grey-light8;

      &::before,
      &::after {
        content: '';
        height: 100%;
        position: absolute;
        background-color: $grey-light8;
        transition: all .3s;
      }

      &::before {
        width: 100%;
        left: 100%;
      }

      &::after {
        width: 51px;
        right: 100%;
      }

      .services_item__action {
        opacity: 1;
        transition: all .3s;
      }
    }

    &:last-child { border-bottom: 0; }

    .services_item {
      &__preview {
        width: 50px;
        min-width: 50px;
        height: 30px;
        background-size: cover;
        background-position: center;
        border-radius: 2px;
        margin-right: 14px;
      }

      &__info { width: 100%; }

      &__title,
      &__descriprion {
        display: flex;
        justify-content: space-between;
        line-height: normal;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 3px;
      }

      &__descriprion {
        color: $grey-light9;
        line-height: normal;
        font-size: 12px;
        margin-bottom: 0;
      }

      &__action {
        position: absolute;
        right: -53px;
        opacity: 0;
        transition: all .3s;

        .v-icon { color: $sub-black; }
      }
    }
  }

</style>
